import { Stack } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useUser } from 'store'
import MainContent, { TableContent } from 'components-shared'
import CustomButton from 'packages/ui/Components/Button'
import useSubscribeRefresh from 'use-subscribe-actions'

import Table from './Table/Table'
import Filters from './components/Filters'

const Advertisements = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [user] = useUser()
  useSubscribeRefresh(() => navigate('/advertisements'))
  return (
    <>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Filters />
        <Stack direction="row" spacing={2}>
          <CustomButton
            sx={{ height: '32px' }}
            startIcon={<i className={'fa-regular fa-plus'} />}
            size="12px"
            onClick={() => navigate('/advertisements/create')}
            disabled={Boolean(user.demo_mode)}
          >
            {t('ui_elements.form_create')}
          </CustomButton>
        </Stack>
      </Stack>
      <MainContent>
        <TableContent>
          <Table />
        </TableContent>
        <Outlet />
      </MainContent>
    </>
  )
}

export default Advertisements
